"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lwm2mURI = void 0;

var object_type_1 = require("./object_type");

var Lwm2mURI =
/** @class */
function () {
  function Lwm2mURI(object, objectInstance, resource, instance, prefix) {
    this.object = object;
    this.objectInstance = objectInstance;
    this.resource = resource;
    this.instance = instance;
    this.prefix = prefix;
  }

  Lwm2mURI.prototype.objectType = function () {
    var obj = "";

    if (this.object != null && this.object.length > 0) {
      obj = this.object;
    }

    return object_type_1.stringToObjectType(obj);
  };

  return Lwm2mURI;
}();

exports.Lwm2mURI = Lwm2mURI;